// https://switcheroo.atlassian.com/ui/gates/4f1e2b18-6248-4080-b46a-4e9d2e49af85/key/rovo_jira_twg_cli_cta_filter
// TAP Trait filtering gate
export const ROVO_JIRA_TWG_CLI_CTA_FILTER_GATE = 'rovo_jira_twg_cli_cta_filter';

// https://switcheroo.atlassian.com/ui/gates/cda93d11-2c97-4f8a-9779-03e8b2e01be1/key/rovo_jira_twg_cli_cta_lifecycle
// Lifecycle (rollout) gate - on/off switch controlling whether Post Office returns this message
export const ROVO_JIRA_TWG_CLI_CTA_LIFECYCLE_GATE = 'rovo_jira_twg_cli_cta_lifecycle';

// https://switcheroo.atlassian.com/ui/gates/8078ffd6-b819-4b3c-b50c-438ed54e1f70/key/rovo_jira_twg_cli_cta
// Experiment gate - controls which cohort the user is in for the experiment
export const ROVO_JIRA_TWG_CLI_CTA_EXPERIMENT = 'rovo_jira_twg_cli_cta';

export const ROVO_JIRA_TWG_CLI_CTA_TREATMENT_PARAM = 'rovo_jira_twg_cli_cta_treatment';

export type RovoJiraTwgCliCtaCohort = 'control' | 'treatment';
export const RovoJiraTwgCliCtaCohort = { CONTROL: 'control', TREATMENT: 'treatment' } as const;
